export const ANNOUNCEMENTS_TABLE_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];

export const ANNOUNCEMENTS_TABLE_SUB_HEADERS = [
  { label: 'URL', key: 'url', noTopBorder: true },          
  { label: 'DESCRIPTION', key: 'description', noTopBorder: true },
  { label: 'DATE FROM', key: 'dateFrom', noTopBorder: true },   
  { label: 'DATE TO', key: 'dateTo', noTopBorder: true },        
  { label: 'VIEWERS', key: 'viewers', noTopBorder: true },     
  { label: 'IMAGE', key: 'image', noTopBorder: true },  
  { label: 'ACTION', key: 'status', noTopBorder: true },
];  
